// First-run gate for the mandatory onboarding step (privacy policy).
//
// The BACKEND is what enforces the step (it rejects admin changes until the policy is
// confirmed). This only makes the panel behave sensibly: while the step is open, navigation
// is sent to the privacy-policy screen instead of letting the admin hit rejected requests.
// Any failure to read the status means "not blocked", so this can never lock anyone out.

const TOKEN_KEY = "apollo-done-token";

let cache = { token: null, known: false, blocked: false };

export const ONBOARDING_ROUTE = "/privacy-policy-settings";
// Screens that stay reachable while the step is open (finish the step, fix the profile)
const ALLOWED_PATHS = [ONBOARDING_ROUTE, "/profile-settings"];

export const isAllowedDuringOnboarding = (path) => ALLOWED_PATHS.some((p) => path === p || path.startsWith(p + "/"));

export function resetOnboardingGate() {
  cache = { token: null, known: false, blocked: false };
}

export function setOnboardingBlocked(blocked) {
  cache = { token: localStorage.getItem(TOKEN_KEY), known: true, blocked: !!blocked };
}

export async function isOnboardingBlocked() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return false;
  if (cache.known && cache.token === token) return cache.blocked;
  try {
    // Lazy import: vue-apollo imports modules that import the router.
    const { apolloClient } = require("@/vue-apollo");
    const { data } = await apolloClient.query({
      query: require("../settings/api/getOnboardingStatus.graphql"),
      fetchPolicy: "network-only",
    });
    const blocked = !!(data && data.getOnboardingStatus && data.getOnboardingStatus.blocked);
    cache = { token, known: true, blocked };
    return blocked;
  } catch (e) {
    return false;
  }
}
